import { useState } from "react";
import NoRecord from "../form/NoRecord";
import { chatRole } from "../../utils/data";
import { pip_TimeAgo } from "../../utils/pip";
import { useSelector, useDispatch } from "react-redux";
import { setActiveChat } from "../../redux/features/chat/chatSlice";
import { joinRoom } from "../../redux/features/chat/chatSocketHandlers";

const ChatSidebar = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const { chatList, activeChat, chatListLoading } = useSelector(
    (s) => s.chat.chat,
  );
  const Loader = ({ size = 40 }) => {
    return <div className="ct_loader" style={{ width: size, height: size }} />;
  };
  if (chatListLoading) {
    return (
      <div className="ct_chat_loader_center">
        <Loader size={50} />
      </div>
    );
    // return <div className="loader">Loading chats...</div>;
  }

  const filtered =
    chatList?.filter((chat) =>
      chat?.opposite_user?.full_name
        ?.toLowerCase()
        .includes(search?.toLowerCase()),
    ) || [];

  console.log({ filtered });

  const openChat = (chat) => {
    dispatch(setActiveChat(chat));
    joinRoom({ conversation_id: chat.conversation_id });
  };

  return (
    <div class="chatlist ct_chatroom_chatlist ">
      <div class="ct_modal-dialog-scrollable ">
        <div class="modal-content ">
          {/* Search Input */}
          <div
            className="ct_search_bg_white shadow-none rounded-0"
            style={{
              borderBottom: "1px solid #e6e6e6",
              marginBottom: "20px",
            }}
          >
            <div class="position-relative ">
              <input
                type="text"
                class="form-control ct_input ct_input_pe_40 ct_input_h_40 ct_border_op_10 ct_border_radius_10 border-0"
                style={{ backgroundColor: "#F8F8F9" }}
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <i class="fa-solid fa-search ct_show_eye"></i>
            </div>
          </div>

          {/* Chat List */}
          <div class="modal-body  ct_custom_scroll">
            <div class="chat-lists  " style={{ height: "calc(100vh - 397px)" }}>
              <div className="ct_pinned_messages">
                {filtered?.length > 0 ? (
                  <div class="chat-list">
                    {filtered?.map((chat) => (
                      <a
                        key={chat.conversation_id}
                        onClick={(e) => {
                          e.preventDefault();
                          openChat(chat);
                        }}
                        class={`d-flex ${chat.conversation_id == activeChat?.conversation_id ? "active2" : ""}`}
                      >
                        <div class="ct_chat_list_grid">
                          <div class="position-relative">
                            <img
                              class="img-fluid ct_img_40"
                              src={
                                chat?.opposite_user?.profile_image ||
                                "../assets/img/user_profile.png"
                              }
                              alt="user img"
                            />
                            {chat.conversation_id !=
                              activeChat?.conversation_id &&
                              chat?.unread_count > 0 && (
                                <span class="active"></span>
                              )}
                          </div>
                          <div class="flex-grow-1 ms-3">
                            <div class="d-flex align-items-center gap-2 justify-content-between">
                              <div>
                                <h3 class="ct_fs_16 mb-0 ct_darkblue_text">
                                <span >  {chat?.opposite_user?.full_name || "#N/A"}{" "}</span>
                                  <span className="ct_fs_12 ct_fw_400">
                                    ({chatRole[chat?.opposite_user?.type] || "#N/A"}
                                    ){" "}
                                  </span>
                                </h3>
                                <p className="ct_fs_12 ct_text_clr_9A96A4 ct_overlay_text">
                                  {chat.last_message || ""}
                                </p>
                              </div>
                              <div className="text-center ms-auto">
                                {chat.conversation_id !=
                                  activeChat?.conversation_id && chat?.unread_count > 0 && (
                                  <p className="mb-0 ct_text_clr_9A96A4 ct_white_nowrap">
                                    {pip_TimeAgo(chat?.last_message_at)}
                                  </p>
                                )}
                                {chat.conversation_id !=
                                  activeChat?.conversation_id &&
                                  chat?.unread_count > 0 && (
                                    <div class="ct_caht_msg_notify mt-1  ">
                                      <span class="mx-auto">
                                        {chat?.unread_count}
                                      </span>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    ))}
                  </div>
                ) : (
                  <NoRecord />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatSidebar;
